import DeliverableModel  from '@/models/services/shop/DeliverableModel';
import ShopServiceModel  from '@/models/ShopServiceModel';
import doc               from '@widesk-core/decorators/doc';
import model             from '@widesk-core/decorators/model';

@model.urnResource('deliverable_exchange')
@doc.path('/deliverable_exchanges/{?id}')
export default class DeliverableExchangeModel extends ShopServiceModel {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'deliverable': id;
		'id': id;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(DeliverableModel) declare deliverable: DeliverableModel;
	// @doc.model(DeliverableExchangeStatusModel) declare deliverableExchangeStatus: DeliverableExchangeStatusModel;
}